import { render, staticRenderFns } from "./metadataInfo.vue?vue&type=template&id=3a33f8f9&scoped=true&"
import script from "./metadataInfo.vue?vue&type=script&lang=js&"
export * from "./metadataInfo.vue?vue&type=script&lang=js&"
import style0 from "./metadataInfo.vue?vue&type=style&index=0&id=3a33f8f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a33f8f9",
  null
  
)

export default component.exports